import { useSortable } from '@dnd-kit/react/sortable'
import {
  faGripDotsVertical,
  faTimesCircle
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { MEMBERS } from '../../../constants/chatRooms'
import Message from '../../Messages/Message'
import MessageWrapper from '../../Messages/MessageWrapper'

const Question = ({ question, index, handleRemove }) => {
  const { ref } = useSortable({ id: question._id, index })

  return (
    <li
      ref={ref}
      className="flex items-center justify-center"
      key={question._id}
    >
      <FontAwesomeIcon icon={faGripDotsVertical} className="fa-1x text-xl" />
      <MessageWrapper
        message={question}
        channel={MEMBERS}
        modView={false}
        index={index}
      >
        <Message message={question} channel={MEMBERS} modView={true} />
      </MessageWrapper>
      <button
        className="hover:text-red-500"
        aria-label="Remove question"
        type="button"
        onClick={() => {
          handleRemove(question)
        }}
      >
        <FontAwesomeIcon icon={faTimesCircle} className="size-4" />
      </button>
    </li>
  )
}

export default Question
